/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import queryString from "query-string"
import dayjs from "dayjs"
import { useEffect, useRef, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"

import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import EtcService from "../../../service/truckcontrol/Etc/etcService"
import {
  TETCDataGetListReq,
  TETCDataGetListRes,
  TKohosya_1,
  TKohosya_2,
} from "../../../service/truckcontrol/Etc/TEtc"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"

import ComboBox from "../../../components/ComboBox"
import { RootState } from "../../../globalStore/rootreducer"
import EtcHimozukeModal from "./EtcHimozukeModal"
import { 区分分類コード } from "../../../constant/enum/codes"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import KubunService from "../../../service/master/kubun/kubunService"
import MonthInput from "../../../components/InputWrapper/MonthInput"
import TextInput from "../../../components/InputWrapper/TextInput"
import dateUtil from "../../../ts/util/dateUtil"
import { showInfoToast } from "../../../components/CustomToast"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import EtcRegisterModal from "./EtcRegisterModal"

//#region [type]
export type TETCデータGrid入力 = TETCDataGetListRes &
  Partial<{
    候補乗務員?: number
  }>

// DefaultComboBox
export type T紐づけ状態 = { name: string; value: any }

//#endregion

/**
 * ETCデータ一覧
 * @returns
 */
const EtcDataList = () => {
  const history = useHistory()
  const location = useLocation()
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  // ref
  const ref明細フォーマットフラグ = useRef<boolean>(false)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "EtcDataList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TETCデータGrid入力>,
    pageSize: number
  ) => {
    return new wjCore.CollectionView(data, {
      pageSize,

      calculatedFields: {
        候補乗務員: (item: TETCデータGrid入力) => {
          let 候補乗務員数 = 0
          if (item.候補乗務員リスト_通常貨物) {
            候補乗務員数 += item.候補乗務員リスト_通常貨物.length
          }
          if (item.候補乗務員リスト_海コン) {
            候補乗務員数 += item.候補乗務員リスト_海コン.length
          }
          return 候補乗務員数
        },
      },

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TETCDataGetListReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に
    let currentSearchCondition: TETCDataGetListReq

    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    setPrevSearchCondition(currentSearchCondition)

    try {
      const res = await new EtcService().getList(currentSearchCondition)
      // formatItemを入れなおすためフラグを切り替え
      ref明細フォーマットフラグ.current = false

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TETCDataGetListReq = queryString.parse(location.search)
    set年月(query.年月 ?? eigyobi)
    setETC紐づけ状態区分コード(query.ETC紐づけ状態区分コード)
    set車番(query.車番)
    set社員コード(query.社員コード)
    set社員氏名(query.社員氏名)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TETCDataGetListReq => {
    return {
      年月: 年月 ? 年月.toString() : eigyobi,
      ETC紐づけ状態区分コード: ETC紐づけ状態区分コード ?? undefined,
      車番: 車番 ?? undefined,
      社員コード: 社員コード ?? undefined,
      社員氏名: 社員氏名 ?? undefined,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TETCDataGetListReq
  ) => {
    return {
      年月: dateUtil.format(searchCondition.年月, "YYYY/MM") ?? "",
      ETC紐づけ状態区分コード: 区分ItemSource?.find(
        (i) =>
          i.区分コード === searchCondition.ETC紐づけ状態区分コード &&
          i.分類コード === 区分分類コード.受注配車_請求支払.ETC紐づけ状態区分
      )?.名称1,
      車番: searchCondition.車番,
      社員コード: searchCondition.社員コード,
      社員氏名: searchCondition.社員氏名,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)
    // 前回検索条件をクリア
    setPrevSearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
    // AlertClear
    dispatch(clearAlert())
  }

  const clearSearchState = () => {
    set年月(eigyobi)
    setETC紐づけ状態区分コード(undefined)
    set車番("")
    ref明細フォーマットフラグ.current = false
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    // 候補乗務員セルのイベント設定
    grid.addEventListener(
      grid.hostElement,
      "click",
      (e: number | wjCore.Point | MouseEvent | HTMLElement) => {
        // 指定ポイントの情報を取得
        let ht = grid.hitTest(e)

        // 通常セルかつ指定列に編集処理を設定する
        const cItem = ht.getColumn()
        if (ht.cellType === 1 && cItem.binding === "候補乗務員") {
          // 選択箇所の行データを取得する
          const rItem: TETCデータGrid入力 = grid.selectedItems[0]
          // 候補乗務員が１以上の場合、引き渡す項目を設定しModal編集前のステート変数を切り替える。
          if (rItem.候補乗務員 != null && rItem.候補乗務員 > 1) {
            set選択行id(rItem.高速料ID)
            setIsChangeStateFlg(true)
          }
        }
      }
    )

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    // ループをフラグで制御？
    if (ref明細フォーマットフラグ.current) return

    // 固定行ヘッダの設定
    for (let r = 0; r < f.rows.length; r++) {
      f.rowHeaders.setCellData(r, 0, r + 1)
    }

    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      const rowData: TETCデータGrid入力 = e.getRow().dataItem
      if (!rowData) return

      // ハイパーリンクボタン風設定
      if (cellBinding === "候補乗務員") {
        // セルに表示Itemがある場合、ハイパーリンク風にCSSをあてる。
        if (e.cell.innerHTML !== "") {
          wjCore.toggleClass(e.cell, "link-text text-center text-primary", true)
        }
      }

      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        //削除済フラグの行はreadonly
        if (e.getRow().dataItem.削除フラグ) {
          wjCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }
      }
    }
    // フォーマットのループ制御
    // ref明細フォーマットフラグ.current = true
  }
  const beforeSubmit = () => {
    setIsConfirmModalShow(true)
  }
  const submit = async () => {
    const gridItems: TETCデータGrid入力[] =
      flexGrid?.collectionView.sourceCollection

    // 送信情報のリスト
    const putList: { 高速料ID: number; 更新日時: string }[] = []

    gridItems.forEach((d) => {
      if (!d.受注配車工程ID) {
        putList.push({ 高速料ID: d.高速料ID, 更新日時: d.更新日時 })
      }
    })
    if (putList.length > 0) {
      try {
        let res = await new EtcService().putEtcHimodukeList({
          年月: prevSearchCondition!.年月!,
          高速料InfoList: putList,
        })
        if (res) {
          showInfoToast(`ETC高速料の紐づけが完了しました`)
          search(queryParse())
        }
      } catch (error) {
        dispatch(setAlerts(error))
      } finally {
        setIsConfirmModalShow(false)
      }
    } else {
      dispatch(setWarningAlerts(["対象のデータがありません。"]))
      setIsConfirmModalShow(false)
    }
  }
  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  //grid内エラー項目格納Array
  // const [errorCellPositionList] = useState<
  //   Array<{ 行ID: symbol; colBinding: string }>
  // >([])

  // modal
  const [選択行id, set選択行id] = useState<number>()
  const [isChangeStateFlg, setIsChangeStateFlg] = useState<boolean>(false)
  const [is受注配車検索Modal, setIs受注配車検索Modal] = useState(false)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  const [年月, set年月] = useState<string | null>()
  const [車番, set車番] = useState<string>()
  const [社員コード, set社員コード] = useState<string>()
  const [社員氏名, set社員氏名] = useState<string>()

  // ComboBoxState
  // 紐づけ状態
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()
  const [ETC紐づけ状態区分コード, setETC紐づけ状態区分コード] = useState<
    string | null
  >()
  const [ETC紐づけ状態区分ItemSource, setETC紐づけ状態区分ItemSource] =
    useState<T区分マスタ[]>()

  const [紐づけ候補リスト_通常貨物, set紐づけ候補リスト_通常貨物] = useState<
    TKohosya_1[]
  >([])
  const [紐づけ候補リスト_海コン, set紐づけ候補リスト_海コン] = useState<
    TKohosya_2[]
  >([])
  const [選択行, set選択行] = useState<TETCDataGetListRes>()

  // 紐づけ状態区分
  const [ETC紐づけ状態区分DataMap, setETC紐づけ状態区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [ETC紐づけ状態区分ComboBox, setETC紐づけ状態区分ComboBox] =
    useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  const [紐づけ状態IsLoadEnded, set紐づけ状態IsLoadEnded] =
    useState<boolean>(false)
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  // 手入力モーダル
  const [etcRegisterModalIsShow, setEtcRegisterModalIsShow] = useState(false)
  const [isEdited, setIsEdited] = useState(false)

  const [prevSearchCondition, setPrevSearchCondition] =
    useState<TETCDataGetListReq>()

  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `ETCデータ一覧`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])

  useEffect(() => {
    Promise.all([new KubunService().getList()]).then(([区分マスタRes]) => {
      set区分ItemSource(区分マスタRes.data)
      区分マスタRes &&
        setETC紐づけ状態区分ItemSource(
          区分マスタRes.data.filter((d) => d.区分コード.length === 1)
        )
      区分マスタRes &&
        setETC紐づけ状態区分DataMap(
          new wjcGrid.DataMap(
            区分マスタRes.data.filter(
              (d) =>
                d.分類コード ===
                区分分類コード.受注配車_請求支払.ETC紐づけ状態区分
            ),
            "区分コード",
            "名称1"
          )
        )
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  // modal制御用
  useEffect(() => {
    // ステート変数の更新確認してからモーダルを表示する。
    if (!isChangeStateFlg) return
    setIs受注配車検索Modal(true)
  }, [isChangeStateFlg])

  useEffect(() => {
    if (isEdited && gridInitialized) {
      const querySearchCondition = queryParse()
      search(querySearchCondition)
      setIsEdited(false)
    }
  }, [isEdited])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">ETCデータ一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-65rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    {/* 固定項目 */}
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div className="w-10rem">
                              <MonthInput
                                id="年月"
                                value={年月}
                                defaultValue={eigyobi}
                                setValue={set年月}
                                isRequired={true}
                                placeholder="年月"
                                autoFocus={true}
                              />
                            </div>
                            <div className="w-18rem">
                              <ComboBox.Kubun
                                placeholder="紐づけ状態"
                                分類コード={
                                  区分分類コード.受注配車_請求支払
                                    .ETC紐づけ状態区分
                                }
                                isAllSelect={true}
                                isRequired={false}
                                itemsSource={ETC紐づけ状態区分ItemSource}
                                isLoadEnded={紐づけ状態IsLoadEnded}
                                setIsLoadEnded={set紐づけ状態IsLoadEnded}
                                selectedValue={ETC紐づけ状態区分コード}
                                setSelectedValue={(v) => {
                                  setETC紐づけ状態区分コード(v)
                                }}
                                ComboBox={ETC紐づけ状態区分ComboBox}
                                setComboBox={
                                  setETC紐づけ状態区分ComboBox
                                }></ComboBox.Kubun>
                            </div>
                            <div className="w-5rem">
                              <TextInput
                                id="車番"
                                name="車番"
                                value={車番}
                                setValue={set車番}
                                maxLength={4}
                                placeholder="車番"
                              />
                            </div>
                            <div className="input-group">
                              <TextInput
                                style={{ width: "5.5rem" }}
                                id="社員コード"
                                name="社員コード"
                                value={社員コード}
                                setValue={set社員コード}
                                maxLength={4}
                                placeholder="社員CD"
                              />
                              <TextInput
                                style={{ width: "12rem" }}
                                id="乗務員"
                                name="乗務員"
                                value={社員氏名}
                                setValue={set社員氏名}
                                maxLength={100}
                                placeholder="乗務員"
                              />
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="text-end">
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            search()
                          }}>
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={`${gridId}_1`}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                isShowGridRowPickupButton={false}
                headerComponent={
                  <>
                    <Button
                      disabled={!prevSearchCondition}
                      onClick={() => {
                        beforeSubmit()
                      }}>
                      紐づけ実行
                    </Button>
                    <Button
                      onClick={() => {
                        setEtcRegisterModalIsShow(true)
                      }}>
                      現金払入力
                    </Button>
                  </>
                }
                gridProperties={{
                  allowAddNew: false,
                }}>
                <wjrGrid.FlexGridColumn
                  binding="車番"
                  width={100}
                  header="車番"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="ETCカード番号"
                  width={180}
                  header="ETC番号"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="日付"
                  width={120}
                  wordWrap={true}
                  header="日付">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TETCデータGrid入力>
                    ) => {
                      let dt = ""
                      if (context.item.日付)
                        dt = dayjs(context.item.日付).format("YYYY/MM/DD")
                      return <>{dt}</>
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="時刻"
                  width={80}
                  header="時刻"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="利用IC自"
                  width={128}
                  header="利用IC_自"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="利用IC至"
                  width={128}
                  header="利用IC_至"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額"
                  width={100}
                  format="n"
                  header="金額"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="ETC紐づけ状態区分コード"
                  dataMap={ETC紐づけ状態区分DataMap}
                  width={180}
                  header="紐づけ状態"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="候補乗務員"
                  width={100}
                  header="候補乗務員">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TETCデータGrid入力>
                    ) => {
                      return (
                        <div
                          className="w-100 h-100"
                          onClick={() => {
                            // 画面全体のスクロール位置の保存
                            gridPageHelper.savePageConditionData(
                              location.pathname
                            )
                            set選択行(context.item)
                            set紐づけ候補リスト_通常貨物(
                              context.item.候補乗務員リスト_通常貨物
                            )
                            set紐づけ候補リスト_海コン(
                              context.item.候補乗務員リスト_海コン
                            )
                            setIs受注配車検索Modal(true)
                          }}>
                          <button className="link-button text-primary">
                            {context.item.候補乗務員}
                          </button>
                        </div>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員コード"
                  width={100}
                  header="乗務員CD"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員氏名"
                  width={100}
                  header="乗務員名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="備考"
                  width={120}
                  header="備考"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="高速料入力区分名称1"
                  width={120}
                  header="高速料入力区分"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>
      <EtcHimozukeModal
        title="乗務員 ETC紐づけ"
        gridId={`${gridId}_Modal_1`}
        isShow={is受注配車検索Modal}
        setIsShow={setIs受注配車検索Modal}
        setChangeStateFlg={setIsChangeStateFlg}
        changeStateFlg={isChangeStateFlg}
        候補者リスト={紐づけ候補リスト_通常貨物}
        候補乗務員リスト_海コン={紐づけ候補リスト_海コン}
        選択行={選択行}
        setIsEdited={setIsEdited}
        ETC高速料id={選択行id}></EtcHimozukeModal>
      <EtcRegisterModal
        title="現金払入力"
        isShow={etcRegisterModalIsShow}
        setIsEdited={setIsEdited}
        setIsShow={setEtcRegisterModalIsShow}></EtcRegisterModal>
    </Container>
  )
}

export default EtcDataList
